import React from "react";
import "./Price.css";
import { useCountry } from "../utility/utility";

const plans = [
  {
    tier: "For Individuals",
    name: "BB Smart",
    tagline: "Best for professionals & growing businesses",
    price: (countryCode) => (countryCode === "ae" ? "199AED" : "₹999"),
    period: "/ year",
    note: "No credit card needed",
    features: [
      "Premium Digital Business Card",
      "Custom Digital Profile",
      "Contacts & Appointments",
      "E-commerce & Portfolio",
      "PVC NFC Card (only 1)",
      "Smart QR Code",
      "Accept & Share Payments",
      "Product Links",
      "Apple Wallet / Google Wallet",
      "AI Chatbot (30 Days Trial)",
    ],
    cta: "Get Started",
    ctaStyle: "btn-outline",
    popular: false,
  },
  {
    bg: "linear-gradient(135deg, #fff 0%, #fff5f0 100%)",
    tier: "For Growing Businesses",
    name: "BB Power",
    tagline: "Best for serious businesses that want automation + visibility",
    price: (countryCode) => (countryCode === "ae" ? "499AED" : "₹2,999"),
    period: "/ year",
    note: "Billed monthly · cancel anytime",
    features: [
      "Premium Business Card",
      "Custom Digital Profile",
      "Contacts, Appointments, E-commerce, Portfolio",
      "Premium Metal NFC Card",
      "Smart QR Code",
      "Payments & Wallet Integration",
      "AI Chatbot (Included) (3 months)",
      "NFC Standee",
      "Review Card",
    ],
    cta: "Get Started",
    ctaStyle: "btn-primary",
    popular: true,
  },
  {
    tier: "For Enterprises",
    name: "BB OS Pro",
    tagline: "Best for high-growth businesses & agencies",
    price: (countryCode) => (countryCode === "ae" ? "999AED" : "₹5,999"),
    period: "/ year",
    note: "Billed monthly · custom plans available",
    features: [
      "Premium Business Card",
      "Custom Digital Profile",
      "Contacts, Appointments, E-commerce, Portfolio",
      "2 Premium Metal NFC Cards",
      "Smart QR Code",
      "Payments & Wallet Integration",
      "AI Chatbot (Advanced) (6 months)",
      "App on Play Store & App Store",
      "NFC Standee",
      "Review Card",
      "Sound Box",
    ],
    cta: "Get Started",
    ctaStyle: "btn-ghost",
    popular: false,
  },
];

export default function Price({ onBookDemo }) {
  const { countryCode } = useCountry();

  return (
    <div className="pricing-wrapper mainclass">
      <div className="pricing-container maxwidth">
        <p className="pricing-label">Pricing Chart</p>
        <h1 className="pricing-headline heading">
          Plans Designed to Grow With You
        </h1>

        <div className="pricing-cards">
          {plans.map((plan) => (
            <div
              key={plan.name}
              className={`pricing-card ${plan.popular ? "popular" : ""}`}
              style={{ backgroundColor: plan.bg || "transparent" }}
            >
              {plan.popular && <div className="popular-badge">🔥 Most Popular</div>}

              <p className="card-tier">{plan.tier}</p>
              <h2 className="card-name">{plan.name}</h2>
              <p className="card-tagline">{plan.tagline}</p>

              <div className="card-price">
                <span className="price-amount">
                  {typeof plan.price === "function"
                    ? plan.price(countryCode)
                    : plan.price}
                </span>
                <span className="price-period">{plan.period}</span>
              </div>

              <hr className="card-divider" />

              <ul className="feature-list">
                {plan.features.map((feature) => (
                  <li key={feature} className="feature-item">
                    <span className="feature-check">✓</span>
                    <span>{feature}</span>
                  </li>
                ))}
              </ul>

              <a
                href="https://dashboard.businessbay.io"
                target="_blank"
                rel="noreferrer"
                className={`btn ${plan.ctaStyle}`}
              >
                {plan.cta}
              </a>
            </div>
          ))}
        </div>

        <div className="guarantee-main">
          <div className="guarantee reveal visible">
            🛡️ 14-Day Money-Back Guarantee — Not happy? Full refund, no questions
            asked.
          </div>
        </div>
      </div>
    </div>
  );
}